import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  validation: {},
  hasTriedToSave: false,
  isDirty: false,
  isSaving: false,
  isLoading: false,
  canContinue: false,
  model: {
    UkCitizenship: '',
    anotherCountry: '',
    otherCountry: ''
  }
};

const citizenshipDetails = createSlice({
  name: 'citizenshipDetails',
  initialState,
  reducers: {
    loadCitizenshipDetails: (state) => {
      state.isLoading = true;
    },
    loadCitizenshipDetailsCompleted: (state, action) => {
      state.model = action.payload;
      state.isLoading = false;
    },
    loadCitizenshipDetailsRejected: (state) => {
      state.isLoading = false;
    },
    modelChange: (state, action) => {
      state.model = action.payload;
      state.isDirty = true;
    },
    fieldChange: (state, { payload: { field, value, section } }) => {
      if (section) {
        state.model[section][field] = value;
      } else {
        state.model[field] = value;
      }
      state.isDirty = true;
    },
    validate: (state, action) => {
      state.validation = action.payload;
    },
    save: (state) => {
      state.isSaving = true;
      state.hasTriedToSave = true;
    },
    saveCompleted: (state) => {
      state.isSaving = false;
    },
    saveCancelled: (state) => {
      state.isSaving = false;
    },
    saveRejected: (state) => {
      state.isSaving = false;
    },
    resetState: () => initialState
  }
});

export { citizenshipDetails };
export const {
  fieldChange,
  loadCitizenshipDetails,
  loadCitizenshipDetailsCompleted,
  loadCitizenshipDetailsRejected,
  modelChange,
  save,
  saveCancelled,
  saveCompleted,
  saveRejected,
  validate,
  resetState
} = citizenshipDetails.actions;
